import { Brand, getBrandFromHostname } from '@lendi/lala-utils';
import { BOT_FIRSTNAME_AUSSIE, BOT_FIRSTNAME_DOMAIN, BOT_FIRSTNAME_LENDI, PRIVACY_POLICY_LINK_AUSSIE, PRIVACY_POLICY_LINK_LENDI, } from './constants';
import { isBrowser } from '@lendi-ui/commons/utils';
export var isDomain = getBrandFromHostname() === Brand.Domain;
export var getPrivacyPolicyLink = function (brand) {
    switch (brand) {
        case Brand.Aussie:
            return PRIVACY_POLICY_LINK_AUSSIE;
        case Brand.Lendi:
        default:
            return PRIVACY_POLICY_LINK_LENDI;
    }
};
export var getFirstNameForBrand = function () {
    var brand = getBrandFromHostname();
    switch (brand) {
        case Brand.Aussie:
            return BOT_FIRSTNAME_AUSSIE;
        case Brand.Domain:
            return BOT_FIRSTNAME_DOMAIN;
        case Brand.Lendi:
        default:
            return BOT_FIRSTNAME_LENDI;
    }
};
// this check the application scoped and return applicationId if there is an application else undefined
export function checkApplicationScope() {
    if (isBrowser) {
        var pathNameArray = window.location.pathname.split('/');
        var indexOfApplicationId = pathNameArray.indexOf('application') + 1;
        var urlParamApplicationId = indexOfApplicationId && pathNameArray[indexOfApplicationId];
        return urlParamApplicationId || undefined;
    }
    else {
        // eslint-disable-next-line no-console
        console.error('window object is not available.');
        return undefined;
    }
}
export var formatInitialPhoneNumber = function (phoneNumber) { return phoneNumber.replace(/(\+61)?0?(4\d{8})/, '$2'); };
export var formattedPhoneNumber = function (phoneNumber) {
    return phoneNumber.replace(/(\+61)0?(4\d{2})(\d{3})(\d{3})/, '$1 $2 $3 $4');
};
//# sourceMappingURL=index.js.map